"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var I18n = require("i18n-js");
var tracker_1 = require("@reverbdotcom/commons/dist/tracker");
var bind_1 = require("../../../bind");
var lodash_1 = require("lodash");
var metadata_helper_1 = require("./metadata_helper");
var mparticle_types_1 = require("@reverbdotcom/commons/dist/elog/mparticle_types");
var componentName = 'CSPCard';
var CSPCard = /** @class */ (function (_super) {
    tslib_1.__extends(CSPCard, _super);
    function CSPCard() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CSPCard.prototype.trackClick = function () {
        var page = this.props.page;
        tracker_1.trackInteraction({
            componentName: componentName,
            type: tracker_1.CSP_TYPE,
            entityId: page.id,
            url: page.webLink(),
            position: this.props.trackPosition,
            mParticleInteraction: {
                componentName: componentName,
                eventName: mparticle_types_1.MParticleEventName.ClickedCSPCard,
                cspId: page.id,
                cspSlug: page.slug,
                brand: '',
                category: '',
                displayStyle: '',
                position: this.props.trackPosition,
                subcategories: '',
            },
        });
    };
    CSPCard.prototype.titleWithBrandRemoved = function () {
        if (!this.props.page) {
            return null;
        }
        if (!this.props.stripBrandFromTitle) {
            return this.props.page.title;
        }
        var brandName = lodash_1.get(this.props, 'page.brand.name');
        if (!brandName) {
            return this.props.page.title;
        }
        var regex = new RegExp("^" + brandName + " ", 'i');
        return this.props.page.title.replace(regex, '');
    };
    CSPCard.prototype.renderPrices = function () {
        if (!this.props.page) {
            return null;
        }
        var price = this.props.page.lowestPrice();
        var count = this.props.page.usedListingsCount + this.props.page.newListingsCount;
        if (!count) {
            return (React.createElement("div", { className: "csp-card__subtitle" }, I18n.t('discovery.comparisonShoppingPages.noneListed')));
        }
        return (React.createElement("div", { className: "csp-card__subtitle", itemScope: true, itemProp: "offers", itemType: "http://schema.org/AggregateOffer" },
            React.createElement(metadata_helper_1.PriceMetaData, { inventory: {
                    usedLowPrice: this.props.page.usedLowPrice,
                    usedTotal: this.props.page.usedListingsCount,
                    newLowPrice: this.props.page.newLowPrice,
                    newTotal: this.props.page.newListingsCount,
                } }),
            I18n.t('discovery.comparisonShoppingPages.priceFromWithCount', {
                count: count,
                price: price.display,
            })));
    };
    CSPCard.prototype.getBackgroundImageStyle = function () {
        if (!this.props.page) {
            return {};
        }
        return { backgroundImage: "url(" + this.props.page.horizontalImageHref() + ")" };
    };
    CSPCard.prototype.renderPlaceholderCard = function () {
        return (React.createElement("div", { className: "csp-card csp-card--placeholder" },
            React.createElement("a", { href: "#" },
                React.createElement("div", { className: "csp-card__image" }),
                React.createElement("div", { className: "csp-card__text" },
                    React.createElement("div", { className: "csp-card__title" }),
                    React.createElement("div", { className: "csp-card__subtitle" })))));
    };
    CSPCard.prototype.render = function () {
        if (!this.props.page) {
            return this.renderPlaceholderCard();
        }
        return (React.createElement("article", { className: "csp-card", onClick: this.trackClick, itemScope: true, itemType: "http://schema.org/Product" },
            React.createElement("a", { href: this.props.page && this.props.page.webLink() },
                React.createElement("div", { className: "csp-card__image", style: this.getBackgroundImageStyle() }),
                React.createElement("div", { className: "csp-card__text" },
                    React.createElement(metadata_helper_1.BrandMetaData, { brandName: lodash_1.get(this.props, 'page.brand.name') }),
                    React.createElement(metadata_helper_1.NameMetaData, { title: this.props.page.title }),
                    React.createElement("h4", { className: "csp-card__title", itemProp: "model" }, this.titleWithBrandRemoved()),
                    this.renderPrices()))));
    };
    tslib_1.__decorate([
        bind_1.default
    ], CSPCard.prototype, "trackClick", null);
    return CSPCard;
}(React.Component));
exports.default = CSPCard;
//# sourceMappingURL=csp_card.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/components/discovery/csp/csp_card.js
// module id = EKoq
// module chunks = 20 21